import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumbs from '../../../shared/breadcrumbs/Breadcrumbs';
import '../../Technical.css';

class ImageInformationV3 extends Component {
	render() {
		return (
			<div className="technical-main">
				<Breadcrumbs />
				<div className="technical-content">
					<h1 className="main-heading">
						ImageInformation Web Service (Version 3)
                    </h1>
					<div>
						<h2 className="main-subheading">ImageInformation</h2>
						<div className="technical-main-content">
							<p>The ImageInformation method is typically used by the Service Aggregator to check the status of a card design.
							The Aggregator should wait until the card design submitted by the Cardholder is Accepted before sending an embossing record to the Bureau.
							If the card design is Denied, the Service Aggregator should trigger the appropriate business procedure to deal with such cases
			(for example, issue the Cardholder with a standard plastic).</p>
							<h3>WSDL URL</h3>
							<p>Thales will provide the WSDL URL for DevServer during the project.</p>
							<br />
							<h3>Request Parameters</h3>
							<ul>
								<li><b>CardImageID</b> (string)
							<p>The unique identifier for the image being requested, This is generated by the Designer Website and passed to the Subscriber during the Handback procedure.
							</p></li>
								<li><b>ImageInformation_Key</b> (GUID string)
								<p>This value identifies the caller and is matched to the Service Aggregator. This guarantees that the caller should have access to the requested CardImageID.
													Thales will provide the Aggregator with the value for this parameter. Also note that a different value will be used on each environment (see the Handover URL section for an explanation of the environments).
							</p></li>
							</ul>
							<br />

							<h3>Response Paramters (<span className="red">New parameters are in red</span>)</h3>
							<ul>
								<li><b>CardImageID</b> (string)
							<p>The same value as the request parameter.</p>
								</li>
								<li><b>DesignState</b> (integer)
							<p>Identifies the current state of the requested card design.</p>
								</li>
								<li><b>ErrorCode</b> (integer)
							<p>An error code describing the error (if any) that occurred during the method call.</p>
								</li>
								<li><b>Handover_Key</b> (GUID string)
							<p>the Handover_Key that was used to create the card design in the Designer Website.</p>
								</li>
								<li><b>RejectionReason</b> (string)
							<p>If the image was rejected in image checking then this will display the reason for the rejection decision.</p>
								</li>
								<li><b>ImageType</b> (string)
							<p>The type of image that was submitted.</p>
								</li>
								<li><b>TransactionApprovalState</b> (string)
							<p>If Transaction Approval option is configured for the product, this will identify whether or not the transaction has been approved for this image.
																If no approval decision has been made on the image then this will be an empty string.
														If Transaction Approval is not configured for the product then this will always be an empty string.</p>
								</li>
								<li><b><span className="red">StockImageCode</span></b> (string)
							<p>This relates to the Price Code set up within gallery management of the PCS Administration site.</p>
								</li>
								<li><b><span className="red">CardPrinted</span></b> (dateTime)
							<p>Identifies the date and time of a card that has been printed. Set by Client</p>
								</li>
								<li><b><span className="red">CardMailed</span></b> (dateTime)
							<p>Identifies the date and time of a card that has been mailed. Set by Client.</p>
								</li>
								<li><b><span className="red">ImageCheckingStartTimeStamp</span></b> (dateTime)
							<p>This identifies the date and time when an image was first image checked.</p>
								</li>
								<li><b><span className="red">ImageCheckingEndTimeStamp</span></b> (dateTime)
							<p>This identifies the date and time when an image was last image checked with a final decision.</p>
								</li>
								<li><b><span className="red">TransactionApprovalStateName</span></b> (string)
								<p>This indicates the Approval state of an image whether Approved, Not Approved, No decision.</p>
								</li>
								<li><b><span className="red">TransactionApprovalStateID</span></b> (integer)
								<p>This is the unique identifier for an image if Transaction Approval is configured for the product.</p>
								</li>
								<li><b><span className="red">AggregatorName</span></b> (string)
								<p>This identifies the company acquiring this service.</p>
								</li>
								<li><b><span className="red">AggregatorID</span></b> (integer)
									<p>The unique identifier for the Aggregator.</p>
								</li>
								<li><b><span className="red">SubscriberName</span></b> (string)
									<p>This identifies the customers obtaining the service offered by the Aggregator.</p>
								</li>
								<li><b><span className="red">SubscriberID</span></b> (interger)
									<p>The unique identifier for the Subscriber.</p>
								</li>
								<li><b><span className="red">ProductName</span></b> (string)
									<p>This identifies the card template e.g Classic, Gold or Platinum.</p>
								</li>
								<li><b><span className="red">ProductID</span></b> (interger)
									<p>The unique identifier of a product.</p>
								</li>
								<li><b><span className="red">DesignCreatedTimeStamp</span></b> (dateTime)
									<p>This identifies the date and time a design was created in the designer website.</p>
								</li>
								<li><b><span className="red">DesignStateTimeStamp</span></b> (dateTime)
									<p>Identifies the date and time of the requested card design in it&apos;s current state.</p>
								</li>
								<li><b><span className="red">DesignStateName</span></b> (string)
									<p>Identifies the name of the current state of the requested card design.</p>
								</li>
								<li><b><span className="red">DesignStateID</span></b> (interger)
									<p>This is a unique identifier of the current state of the requested card design.</p>
								</li>
								<li><b><span className="red">DesignTransferStateName</span></b> (string)
									<p>Identifies the progress status of a requested card design, it identifies whether the requested card design has been transferred, still in queue, if the transfer errored or it&apos;s in the middle of a tranfer.</p>
								</li>
								<li><b><span className="red">DesignTransferStateID</span></b> (integer)
									<p>This is the value that identifies the design transfer state of a requested card design.</p>
								</li>
								<li><b><span className="red">DesignTransferTimeStamp</span></b> (dateTime)
									<p>This identifies the date and time a requested card design is transferred.</p>
								</li>
								<li><b><span className="red">EmailAddress</span></b> (string)
									<p>This identifies where users will be sent an email notifying them of the decisions regarding their submitted designs.</p>
								</li>
								<li><b><span className="red">EmailSent</span></b> (boolean)
									<p>This identifies whether or not an email has been sent. This will return &quot;true&quot; or &quot;false&quot;.</p>
								</li>
								<li><b><span className="red">LanguageId</span></b> (string)
									<p>This indicates the language used if the subscriber is multi lingual.</p>
								</li>
								<li><b><span className="red">PublicImage</span></b> (boolean)
									<p>Identifies whether a design should be made public. This will return &quot;true&quot; or &quot;false&quot;.</p>
								</li>
								<li><b><span className="red">ClientRefererId</span></b> (string)
									<p>This refers to another design image created by a previous customer. Normally used with ShareMyDesign and Social Card.</p>
								</li>
								<li><b><span className="red">TransactionApprovalTimeStamp</span></b> (dateTime)
									<p>This indicates the date and time when the transaction was approved.</p>
								</li>
								<li><b><span className="red">TransactionApprovalComment</span></b> (string)
									<p>This indicates an approval decision for an image.</p>
								</li>
								<li><b><span className="red">TransferredDefaultImage</span></b> (boolean)
									<p>This is the default image that will be sent if an image was rejected.</p>
								</li>
								<li><b><span className="red">BatchFileName</span></b> (string)
									<p>This identifies the filename assigned to a batch file.</p>
								</li>
								<li><b><span className="red">BatchFileTimeStamp</span></b> (dateTime)
									<p>This indicates the date and time the batch file was sent.</p>
								</li>
								<li><b><span className="red">Processed</span></b> (dateTime)
									<p>This indicates whether a batch file has been sent.</p>
								</li>
								<li><b><span className="red">CustomImagePricePoint</span></b> (string) <b><sup>(<span className="smallRed">Not yet implemented</span>)</sup></b>
									<p>This indicates a price point per product for any uploaded image</p></li>
								<li><b><span className="red">TextLayerPricePoint</span></b>(string) <b><sup>(<span className="smallRed">Not yet implemented</span>)</sup></b>
									<p>This indicates a value of the price point per product for any uploaded image.</p>
								</li>
							</ul>
							<br />
							<div>
								<h3>
									Design States</h3>
								<ul>
									<li><b>-1 (Error)</b>: an error occurred with the method call (see Error Codes)</li>
									<li><b>1 (No session)</b>: there is no card design for that CardImageID</li>
									<li><b>2 (Abandoned Session)</b>: the Cardholder never completed the design process
                                    and so did not submit a card design</li>
									<li><b>3 (In Work)</b>: the Cardholder is currently designing his card.</li>
									<li><b>4 (Submitted)</b>: the card design has not been Image Checked yet</li>
									<li><b>5 (Denied)</b>: the card design was rejected in Image Checking</li>
									<li><b>6 (Accepted)</b>: the card design has been Accepted in Image Checking</li>
									<li><b>7 (Hold)</b>: the image is in the Audit Review Period. It hasn’t been finally
                                    Accepted or Denied yet. See the Image Checking section for more details.</li>
								</ul>
								<br />
							</div>
							<div>
								<h3>
									Design State Names</h3>
								<ul>
									<li><b>-1 (Error)</b>: an error occurred with the method call (see Error Codes)</li>
									<li><b>1 (No session)</b>: there is no card design for that CardImageID</li>
									<li><b>2 (Abandoned Session)</b>: the Cardholder never completed the design process
                                    and so did not submit a card design</li>
									<li><b>3 (In Work)</b>: the Cardholder is currently designing his card.</li>
									<li><b>4 (Submitted)</b>: the card design has not been Image Checked yet</li>
									<li><b>5 (Denied)</b>: the card design was rejected in Image Checking</li>
									<li><b>6 (Accepted)</b>: the card design has been Accepted in Image Checking</li>
									<li><b>7 (Hold)</b>: the image is in the Audit Review Period. It hasn’t been finally
                                    Accepted or Denied yet. See the Image Checking section for more details.</li>
									<li><b>8 (Referred)</b>: the image has been referred by a previous client.</li>
									<li><b>9 (Other)</b>: this will only occur in special occassion, for instance an image
                                    redraft is needed. </li>
								</ul>
								<br />
							</div>
							<div>
								<h3>
									Design TransferState ID</h3>
								<ul>
									<li><b>0 (Transferring)</b>: the design image is yet to be transferred.</li>
									<li><b>1 (Error)</b>: an error occurred with the transfer.</li>
									<li><b>2 (transferred)</b>: the design image has been transferred.</li>
									<li><b>3 (Completed)</b>: the design transfer was receipted as successful.</li>
									<li><b>4 (InQueue)</b>: the design image is waiting to be transferred. </li>
								</ul>
								<br />
							</div>
							<div>
								<h3>
									Image Types</h3>
								<ul>
									<li><b>Custom</b>: a custom image uploaded by the user</li>
									<li><b>Gallery</b>: an image chosen from the stock image gallery</li>
									<li><b>Unkown</b>: this should never be seen</li>
								</ul>
								<br />
							</div>
							<div>
								<h3>
									Transaction Approval States</h3>
								<ul>
									<li><b>0 (No decision)</b>: no transaction approval descision for this image has been
                                    indicated</li>
									<li><b>1 (Approved)</b>: the transaction for this image has been indicated as approved</li>
									<li><b>2 (Not approved)</b>: the transaction for this image has been indicated as unapproved</li>
								</ul>
								<br />
							</div>
							<div>
								<h3>
									Error Codes</h3>
								<ul>
									<li><b>-2 (Unexpected system error)</b>: An internal error occurred. This indicates that the caller is not allowed to make a request due to IP transparency check.</li>
									<li><b>-1 (Unexpected system error)</b>: An internal error occurred. The caller should
																			attempt to call the method again. If a high number of such errors are encountered,
                                    the problem should be escalated to manual operators at Thales.</li>
									<li><b>0 (Success)</b>: The method call was successful.</li>
									<li><b>1 (CardImageID is invalid)</b>: The CardImageID isn’t a valid identifier.</li>
									<li><b>2 (ImageInformation_Key is invalid or doesn’t match CardImageId)</b>: The CardImageID
																			and ImageInformation_Key don’t match. This error will usually occur when an invalid
                                    or incorrect ImageInformation_Key is used.</li>
								</ul>
								<br />
							</div>
						</div>
						<div className="document-content-back">
							<Link className="document-content-link" to='/technical/imageinformation'>Back</Link>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default ImageInformationV3;